import { Link } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import FormLogin from "./components/FormLogin";
import homeImg from '../../../assets/images/home.svg';
import { useSearchParams } from 'react-router-dom';

const Login = () => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect');

  return (
    <Layout>
      <div className="Login">
        <div className="Login-form">
          <h1 className="h1">Welcome back!</h1>
          <FormLogin redirectUrl={redirectUrl} />
        </div>
        <div className="right">
          <div className="content">
            <div>
              <img className="star" src="https://storage.googleapis.com/constlending-borrowers/static/star-vector.svg" />
            </div>
            <p className="phrase">
              &quot;Dealing with multiple lenders is SO exhausting and wondering if I&apos;d get financing made me apprehensive about chasing deals. Thanks to you, I can just focus on buying properties!&quot;
            </p>
            <div className="author">
              <b>Chandra M</b>
              <br></br>
              Real estate investor
            </div>
          </div>
          <div>
            <img className="home" src={homeImg} />
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Login;
